import { TooltipPopoverV2 } from "../TooltipPopoverV2";
import {
  InlineTooltipIconButtonV2,
  type InlineTooltipIconButtonV2Props,
} from "../InlineTooltipIconButtonV2";

export type InputLabelTopTooltipProps = {
  iconButtonProps: Omit<
    InlineTooltipIconButtonV2Props,
    "variant" | "typographyVariant" | "onPress"
  >;
  otherIconButtonProps: Pick<
    InlineTooltipIconButtonV2Props,
    "variant" | "typographyVariant"
  >;
  contentProps: {
    children: React.ReactNode;
  };
};

function InputLabelTopTooltip(props: InputLabelTopTooltipProps) {
  const { iconButtonProps, otherIconButtonProps, contentProps } = props;

  return (
    <TooltipPopoverV2>
      <TooltipPopoverV2.Trigger>
        <InlineTooltipIconButtonV2
          {...iconButtonProps}
          {...otherIconButtonProps}
        />

        <TooltipPopoverV2.Content {...contentProps} />
      </TooltipPopoverV2.Trigger>
    </TooltipPopoverV2>
  );
}

export default InputLabelTopTooltip;
